import { FilterSimpleFilledIcon, FilterSimpleIcon } from "@components/icon";
import React, { useCallback } from "react";

import { IconSize } from "../../enums";
import TestIds from "../../testIds";
import { IconButtonStyled, ItemDescription, ItemLabel, ItemStyled, ItemValue } from "./ReadOnlyList.styles";

export enum ListType {
    Standard,
    Condensed
}

export interface IReadOnlyListItem {
    id?: string; // used to identify the item in the list, e.g. in smart filter click callback
    label: string;
    value: string | React.ReactElement;
    description?: string;
    onSmartFilterClick?: (id: string, shouldRemove: boolean) => void;
    isSmartFilterDisabled?: boolean;
    isSmartFilterApplied?: boolean;
}

export interface IProps extends IReadOnlyListItem {
    type?: ListType;
}

export function ReadOnlyListItem({
                                     id,
                                     label,
                                     value,
                                     type,
                                     description,
                                     onSmartFilterClick,
                                     isSmartFilterDisabled,
                                     isSmartFilterApplied
                                 }: IProps): React.ReactElement {

    const handleClick = useCallback((event: React.MouseEvent) => {
        onSmartFilterClick(id, isSmartFilterApplied);
    }, [onSmartFilterClick, id, isSmartFilterApplied]);

    const Icon = isSmartFilterApplied ? FilterSimpleFilledIcon : FilterSimpleIcon;

    return (
        <ItemStyled type={type} data-testid={TestIds.ReadOnlyListItem}>
            <ItemLabel type={type} withIcon={!!onSmartFilterClick} data-testid={TestIds.ReadOnlyListItemLabel}>
                {label}:
                {onSmartFilterClick && (
                        <IconButtonStyled title="" onClick={handleClick}
                                          isTransparent
                                          isDisabled={isSmartFilterDisabled}
                                          isActive={false}>
                            <Icon width={IconSize.XS} height={IconSize.XS}/>
                        </IconButtonStyled>
                )}
            </ItemLabel>
            <ItemValue data-testid={TestIds.ReadOnlyListItemValue}>{value}
                {description && <ItemDescription>{description}</ItemDescription>}
            </ItemValue>
        </ItemStyled>
    );
}